import React from 'react';

import DestructiveActionMenuItem from '@dashboard/components/destructive-action-triggers/DestructiveActionMenuItem';
import { alertSuccess } from '@dashboard/contexts/SnackbarManager/store';
import { useArchiveWorkflowMutation } from '@dashboard/generated/wp/platform';
import usePlatformNavigator from '@dashboard/hooks/navigate/usePlatformNavigator';
import { ArchiveOutlined } from '@mui/icons-material';

import useCurrentWorkflowId from '../useCurrentWorkflowId';

type Props = {
  onClose: () => void;
};
export default function ArchiveWorkflowButton({ onClose }: Props) {
  const id = useCurrentWorkflowId();
  const [archive, { loading }] = useArchiveWorkflowMutation();
  const navigator = usePlatformNavigator();

  return (
    <DestructiveActionMenuItem
      buttonIcon={<ArchiveOutlined fontSize="small" />}
      buttonText="Archive workflow"
      description="This will move this workflow out of your workflows page."
      title="Archive workflow?"
      loading={loading}
      onSubmit={async () => {
        await archive({ variables: { id } });
        alertSuccess('Workflow archived');
        onClose();
        navigator.listWorkflows();
      }}
      confirmButtonLabel="Yes, archive"
    />
  );
}
